import setRuleForSelector from './set-rule-for-selector';
import getCssVariablesMap from './get-css-variables-map';
import getCssVariableNameByColor from './get-css-variable-name-by-color';
import createRootVariableName from './create-root-variable-name';
import getTextVariableName from './get-text-variable-name';

const createCssTextRule = ({
  blockId,
  surfaceAttribute,
  name,
  propertyValue,
  customStylesheet,
}) => {
  let cssVariableName = name;
  let rootRule = Array.from(customStylesheet.cssRules).find(
    (rule) => rule.selectorText === ':root'
  );

  if (!rootRule) {
    customStylesheet.insertRule(`:root {}`, 0);
    rootRule = customStylesheet.cssRules[0];
  }

  const rootMap = getCssVariablesMap(rootRule.style.cssText);

  if (!cssVariableName || !rootMap[cssVariableName]) {
    cssVariableName =
      cssVariableName || getCssVariableNameByColor(propertyValue) || createRootVariableName();

    rootRule.style.cssText += `${cssVariableName}: ${propertyValue}`;
  }

  const textVariableName = getTextVariableName(cssVariableName);

  const idRule = `${textVariableName}: var(${cssVariableName})`;
  setRuleForSelector(`#${blockId} .${surfaceAttribute}`, customStylesheet, idRule);

  return {
    cssVariableName,
    textVariableName,
  };
};

export default createCssTextRule;
